import React from "react";
import "./Navbar.css";
import NavbarTag from "react-bootstrap/Navbar";
import BaraLogo from "../Logo/BaraLogo";

const Navbar = () => {
  return (
    <header>
      <div className="main-container">
        <NavbarTag.Brand href="/" className="logo-link">
          <BaraLogo height={32} color="#111111" />
        </NavbarTag.Brand>
      </div>
    </header>
  );
};

export default Navbar;
